"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, Tabs, TabsContent, TabsList, TabsTrigger } from "@/src/components";

export default function DocsBlocksHorizontalTabs() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Horizontal Tabs
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A horizontal tab navigation pattern for organizing content into switchable panels.
          </Text>
        </div>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Horizontal tabs with content panels</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <Tabs defaultValue="overview" className="w-full">
            <TabsList className="grid w-full grid-cols-3">
              <TabsTrigger value="overview">Overview</TabsTrigger>
              <TabsTrigger value="analytics">Analytics</TabsTrigger>
              <TabsTrigger value="reports">Reports</TabsTrigger>
            </TabsList>
            <TabsContent value="overview" className="p-4 border rounded-lg mt-4">
              <Text className="text-sm text-muted-foreground">
                Overview content goes here. Display summary information and key metrics.
              </Text>
            </TabsContent>
            <TabsContent value="analytics" className="p-4 border rounded-lg mt-4">
              <Text className="text-sm text-muted-foreground">
                Analytics content goes here. Show charts, graphs, and detailed data.
              </Text>
            </TabsContent>
            <TabsContent value="reports" className="p-4 border rounded-lg mt-4">
              <Text className="text-sm text-muted-foreground">
                Reports content goes here. Display generated reports and exports.
              </Text>
            </TabsContent>
          </Tabs>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Usage</CardTitle>}
          contentClassName="p-6"
        >
          <ul className="space-y-2 text-sm">
            <li>• Use for switching between related content sections</li>
            <li>• Keep tab labels short (1-2 words)</li>
            <li>• Limit to 5-7 tabs maximum</li>
            <li>• Consider using icons with labels for better recognition</li>
          </ul>
        </SectionCard>
      </Section>
    </>
  );
}
